var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "apps_icon",
    d: "M10.063,28a2.063,2.063,0,1,1,1.469-3.531A2.063,2.063,0,0,1,10.063,28ZM18,28a2.028,2.028,0,1,1,1.469-.594A1.995,1.995,0,0,1,18,28Zm7.938,0a2.028,2.028,0,1,1,1.469-.594A1.995,1.995,0,0,1,25.938,28ZM10.063,20.063a2.063,2.063,0,1,1,1.469-3.531,2.063,2.063,0,0,1-1.469,3.531Zm7.937,0a2.028,2.028,0,1,1,1.469-.594A2,2,0,0,1,18,20.063Zm7.938,0a2.028,2.028,0,1,1,1.469-.594A2,2,0,0,1,25.938,20.063ZM10.063,12.125A2.028,2.028,0,0,1,8,10.063,2.028,2.028,0,0,1,10.063,8a2.028,2.028,0,0,1,2.063,2.063,2.028,2.028,0,0,1-2.063,2.063Zm7.937,0a2.028,2.028,0,0,1-2.062-2.062,2.063,2.063,0,1,1,3.531,1.469A2,2,0,0,1,18,12.125Zm7.938,0a2.028,2.028,0,0,1-2.062-2.062,2.063,2.063,0,1,1,3.531,1.469A2,2,0,0,1,25.938,12.125Z",
    transform: "translate(-8 -8)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsIcon);
export default __webpack_public_path__ + "static/media/apps_icon.213c1fb788a6ead91777f95a5243c458.svg";
export { ForwardRef as ReactComponent };